var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M22 12a9.86 9.86 0 0 1-1.059 4.47A10 10 0 0 1 12 22a9.86 9.86 0 0 1-4.47-1.059L2 22l1.059-5.53A9.86 9.86 0 0 1 2 12a10 10 0 0 1 5.53-8.941A9.86 9.86 0 0 1 12 2h.588A9.977 9.977 0 0 1 22 11.412z",
  vectorEffect: "non-scaling-stroke"
})));
export default SvgChat;